const formMixin = {
  methods: {
    goback() {
      router.go(-1)
    }
  }
}

export default formMixin



// WEBPACK FOOTER //
// ./src/assets/js/form_com.js